import React from "react";
import Table from "../../../../../components/Table";
import { regionsPageLoad } from "../../../actions/regions";
import { regions, regionsLoadInProgress } from "../../../selectors/regions";
import { connect } from "react-redux";
import PageTitle from "../../../components/PageTitle";
import { push } from "react-router-redux";
import { Button, Glyphicon, Panel } from "react-bootstrap";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import DisableBadge from "sc/ui/sites/oncall/components/DisableBadge";

export default connect(
  (state, ownProps) => ({
    regions: regions(state),
    loading: regionsLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(regionsPageLoad()),
    onAddRegion: () => dispatch(push("/regions/new")),
    onEditRegion: id => dispatch(push(`/region/edit/${id}`)),
  }),
)(
  componentWithLoadTrigger(props => {
    const actions = [
      {
        id: "edit-region",
        text: " Edit",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-pencil",
        onClick: props.onEditRegion,
      },
    ];

    const columns = [
      {
        header: "Name",
        data: region => region.name,
        badges: region => {
          const allBadges = [];
          if (!region.enabled)
            allBadges.push([<DisableBadge key="disabled-badge" />]);
          return allBadges;
        },
      },
    ];

    return (
      <div id="regions-list-page">
        <PageTitle title="Regions" />
        <Button
          id="add-region"
          onClick={props.onAddRegion}
          className="btn-success"
        >
          <Glyphicon glyph="glyphicon glyphicon-plus" />
          &nbsp;Add New Region
        </Button>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Region list</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table
              data={props.regions}
              columns={columns}
              actions={actions}
              identityProperty="id"
              noDataMessage="No regions defined"
              loading={props.loading}
              loadingMessage="Loading..."
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/regions/List.js